<mat-dialog-content>
  <div class="flex flex-col gap-6 p-4">
    <div class="flex flex-col items-center text-center">
      <h1 class="font-semibold text-2xl text-gray-800 mb-2">
        Selecciona tu bodega
      </h1>
      <p class="text-gray-500 text-sm">
        Elige la bodega con la que vas a trabajar durante esta sesión
      </p>
    </div>

    <div class="flex flex-col gap-3 max-h-[400px] overflow-y-auto">
      @for (warehouse of warehouses; track warehouse.code) {
        <div
          (click)="selectWarehouse(warehouse.code!)"
          class="warehouse-card p-4 rounded-2xl border-2 cursor-pointer transition-all duration-200"
          [ngClass]="isSelected(warehouse.code!) ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-300 hover:bg-gray-50'">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-xl flex items-center justify-center"
                [ngClass]="isSelected(warehouse.code!) ? 'bg-orange-500' : 'bg-gray-100'">
                <i class="fi-rr-box text-lg"
                  [ngClass]="isSelected(warehouse.code!) ? 'text-white' : 'text-gray-500'"></i>
              </div>
              <div class="flex flex-col">
                <span class="font-semibold text-base"
                  [ngClass]="isSelected(warehouse.code!) ? 'text-orange-700' : 'text-gray-800'">
                  {{ warehouse.name }}
                </span>
              </div>
            </div>
            @if (isSelected(warehouse.code!)) {
              <i class="fi-rr-check-circle text-2xl text-orange-500"></i>
            }
          </div>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="gap-2 flex flex-row justify-end px-6 pb-6">
  <button
    class="rounded-3xl flex items-center gap-2 bg-orange-500 text-white py-3 px-8 cursor-pointer hover:bg-orange-600 disabled:bg-orange-200 disabled:cursor-not-allowed transition-all"
    (click)="confirm()"
    [disabled]="!selectedCode">
    <span class="text-base font-medium">Continuar</span>
    <i class="fi-rr-arrow-right text-base flex"></i>
  </button>
</mat-dialog-actions>
